var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.35,
    height: 17.998,
    viewBox: "0 0 17.35 17.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_201",
    "data-name": "Subtraction 201",
    d: "M16820.895,8638h-12.443a2.452,2.452,0,0,1-2.453-2.444v-13.105a2.454,2.454,0,0,1,2.453-2.448h12.443a2.467,2.467,0,0,1,2.453,2.448v13.105A2.465,2.465,0,0,1,16820.895,8638Zm-10.32-4.8a.614.614,0,0,0,0,1.229h8.191a.614.614,0,0,0,0-1.229Zm0-3.276a.616.616,0,0,0,0,1.232h5.734a.616.616,0,1,0,0-1.232Zm3.277-5.729a.615.615,0,0,0-.436.181l-2.457,2.453a.612.612,0,0,0,.439,1.047.593.593,0,0,0,.43-.178l2.023-2.021,1.207,1.207a.589.589,0,0,0,.412.179h.039a.606.606,0,0,0,.443-.216l2.463-2.866a.616.616,0,0,0-.471-1.015.605.605,0,0,0-.467.216l-2.027,2.36-1.164-1.165A.615.615,0,0,0,16813.852,8624.2Z",
    transform: "translate(-16805.998 -8620.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIconColor);
export default __webpack_public_path__ + "static/media/reports_icon_color.476795406630bcc9323025d5c92669af.svg";
export { ForwardRef as ReactComponent };